import { call, CallEffect, put, takeLatest } from 'redux-saga/effects';
import Notify, { AlertTypes } from 'Services/notification';
import RecordsService from 'Services/records';
import { getErrorDetail } from 'Services/errors';
import { ResponseType, RecordType } from 'Types/common';
import * as types from './types';
import { getStateAction, setStageAction } from './actions';

export function* saveUserDataSaga({
  payload,
}: ReturnType<typeof getStateAction>):
  | Generator<CallEffect<ResponseType<RecordType>>, void, never>
  | Generator {
  try {
    const response: ResponseType<RecordType> = yield call(RecordsService.setUserData, payload);
    const { data } = response;
    const nextStage = data?.item?.stage;
    yield put(setStageAction(nextStage));
  } catch (error) {
    yield call(Notify.sendNotification, getErrorDetail(error), AlertTypes.error);
  }
}

export function* watchValidationsSaga(): Generator {
  yield takeLatest(types.SAVE_USER_DATA_TYPE, saveUserDataSaga);
}
